import client from '../../base-api';

const serviceURL = '/dashboard/head-of-marketing';

const dashboardHeadMarketingService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },
}

export default dashboardHeadMarketingService;